/* Klaviyo client subscribe. finder_email fires only after a 202. The address never goes on the dataLayer. -- SG 20261026 */

const RETRY_MS = 800;

function emit(name: string, detail: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  const target = window as unknown as { dataLayer?: Array<Record<string, unknown>> };
  target.dataLayer = target.dataLayer || [];
  target.dataLayer.push({ event: name, ...detail });
}

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

async function postSubscription(companyId: string, body: unknown): Promise<number> {
  const response = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(companyId), {
    method: "POST",
    headers: {
      "Content-Type": "application/vnd.api+json",
      revision: "2025-01-15",
    },
    body: JSON.stringify(body),
  });
  return response.status;
}

export function isValidEmail(email: string): boolean {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
}

export async function subscribeToKlaviyo(
  email: string,
  options: { companyId: string; listId: string; properties: Record<string, unknown>; source?: string }
): Promise<{ ok: boolean; status: number }> {
  if (!options.companyId) {
    emit("finder_email_failed", { status: 0 });
    return { ok: false, status: 0 };
  }

  const profile: Record<string, unknown> = {
    email,
    properties: options.properties || {},
    subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } },
  };
  const body: any = {
    data: {
      type: "subscription",
      attributes: {
        custom_source: options.source || "Sleep Finder",
        profile: { data: { type: "profile", attributes: profile } },
      },
    },
  };
  if (options.listId) {
    body.data.relationships = { list: { data: { type: "list", id: options.listId } } };
  }

  let status = 0;
  try {
    status = await postSubscription(options.companyId, body);
    if (status === 429) {
      await delay(RETRY_MS);
      status = await postSubscription(options.companyId, body);
    }
  } catch (error) {
    console.warn("SleepFinder subscribe", error);
    emit("finder_email_failed", { status: 0 });
    return { ok: false, status: 0 };
  }

  if (status === 202) {
    try {
      const klaviyo = (window as unknown as { klaviyo?: { identify?: (props: Record<string, unknown>) => void } }).klaviyo;
      if (klaviyo && klaviyo.identify) klaviyo.identify({ email, ...(options.properties || {}) });
    } catch (error) {
      console.warn("SleepFinder identify", error);
    }
    emit("finder_email", { list: options.listId || "" });
    return { ok: true, status };
  }
  emit("finder_email_failed", { status });
  return { ok: false, status };
}
